module.exports = __webpack_public_path__ + "static/media/institute-23-min.183493a4.webp";